'use client';

import * as React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { TableRow, TableCell } from '@/components/ui/table';

interface CustomersTableSkeletonProps {
    rows?: number;
}

/**
 * CustomersTableSkeleton component for displaying loading state
 * Returns only table rows to be inserted into existing table structure
 */
export function CustomersTableSkeleton({ rows = 8 }: CustomersTableSkeletonProps) {
    return (
        <SkeletonTheme baseColor="#f8fafc" highlightColor="#f1f5f9" borderRadius="0.375rem">
            <>
                {Array.from({ length: rows }, (_, index) => (
                    <TableRow key={index}>
                        {/* Select Checkbox */}
                        <TableCell className="w-10">
                            <Skeleton height={16} width={16} />
                        </TableCell>

                        {/* Customer ID Badge */}
                        <TableCell>
                            <Skeleton height={24} width={120} borderRadius="0.75rem" />
                        </TableCell>

                        {/* Store */}
                        <TableCell className="w-32">
                            <Skeleton height={16} width={100} />
                        </TableCell>

                        {/* Email */}
                        <TableCell className="w-48">
                            <Skeleton height={16} width={180} />
                        </TableCell>

                        {/* First Name */}
                        <TableCell className="w-32">
                            <Skeleton height={16} width={100} />
                        </TableCell>

                        {/* Last Name */}
                        <TableCell className="w-32">
                            <Skeleton height={16} width={100} />
                        </TableCell>

                        {/* Last Order */}
                        <TableCell className="w-32">
                            <Skeleton height={24} width={100} borderRadius="0.75rem" />
                        </TableCell>

                        {/* Browser */}
                        <TableCell className="w-40">
                            <div className="space-y-1">
                                <Skeleton height={14} width={120} />
                                <Skeleton height={12} width={80} />
                            </div>
                        </TableCell>

                        {/* Operating System */}
                        <TableCell className="w-32">
                            <div className="space-y-1">
                                <Skeleton height={14} width={100} />
                                <Skeleton height={12} width={60} />
                            </div>
                        </TableCell>

                        {/* Device Type */}
                        <TableCell className="w-28">
                            <Skeleton height={20} width={80} borderRadius="0.75rem" />
                        </TableCell>

                        {/* Device Model */}
                        <TableCell className="w-32">
                            <Skeleton height={16} width={100} />
                        </TableCell>

                        {/* IP Address */}
                        <TableCell className="w-36">
                            <Skeleton height={16} width={120} />
                        </TableCell>

                        {/* Location */}
                        <TableCell className="w-40">
                            <div className="space-y-1">
                                <Skeleton height={14} width={140} />
                                <Skeleton height={18} width={40} borderRadius="0.75rem" />
                            </div>
                        </TableCell>

                        {/* Last Seen */}
                        <TableCell className="w-36">
                            <Skeleton height={16} width={120} />
                        </TableCell>

                        {/* Created At */}
                        <TableCell className="w-36">
                            <Skeleton height={16} width={120} />
                        </TableCell>
                    </TableRow>
                ))}
            </>
        </SkeletonTheme>
    );
}
